// FavoriteListPanel.jsx
import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../services/store";
import StockGrid from "./StockGrid";

export default observer(function FavoriteListPanel() {
  const store = useStore();
  const [input, setInput] = useState("");
  const [sortBySector, setSortBySector] = useState(false);

  const symLower = input.trim().toLowerCase();
  const exists =
    symLower && store.favoriteList.some((s) => s.toLowerCase() === symLower);

  const onAdd = (e) => {
    e.preventDefault();
    if (!symLower || exists) return;
    store.addToFavoriteList(symLower);
    setInput("");
  };

  const onDelete = (e) => {
    e.preventDefault();
    if (!symLower || !exists) return;
    store.removeFromFavoriteList(symLower);
    setInput("");
  };

  //console.log(JSON.stringify(store.favoriteList));
  return (
    <div>
      <form onSubmit={onAdd} className="flex items-center mb3">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onFocus={() => store.setAllowShortCut(false)}
          placeholder="symbol (e.g., aapl)"
          className="w-40 pv2 ph3 br2 ba b--black-20 mr4"
        />
        <button
          type="submit"
          className="pv2 ph3 br2 bn white hover-bg-dark-blue fw6"
          style={{ backgroundColor: "#357edd", width: 100 }}
        >
          Add
        </button>
        <button
          type="button"
          onClick={onDelete}
          disabled={!exists}
          className="pv2 ph3 br2 bn white fw6 ml2"
          style={{
            backgroundColor: exists ? "#e53e3e" : "#9ca3af",
            cursor: exists ? "pointer" : "not-allowed",
            width: 100,
          }}
        >
          Delete
        </button>

        <label
          className="flex items-center ml3 f6 mid-gray"
          style={{ gap: 8, cursor: "pointer", userSelect: "none" }}
        >
          <input
            type="checkbox"
            role="switch"
            checked={sortBySector}
            onChange={(e) => setSortBySector(e.target.checked)}
          />
          Sector order
        </label>
      </form>

      <StockGrid
        basePath="/csv-adv"
        source="hotlist"
        sortBySector={sortBySector}
      />
    </div>
  );
});
